export default {
  appName: 'Archer Jordan',
  authTokenName: process.env.AUTH_TOKEN_NAME || 'arrow_access_token',
  refreshTokenName: process.env.REFRESH_TOKEN_NAME || 'arrow_refresh_token',
};
